import { all, takeLatest, call, fork, put, select, take } from "redux-saga/effects";
import { messages, messagesRedirect, success, deleteData } from "../../components/messageBox";
import * as types from "../../constants/actionTypes";
import moment from "moment";
import Config from "../../service/Config";
import Endpoint from "../../service/Endpoint";
import { GET, POST } from "../../service/api";
import { Header } from "../../constants/headers";
import { setLoader } from "./actions";
import * as configBase from "../../config";

const getStateAuth = (state) => state.Auth;

export function* postLogin(params) {
  try {
    yield put(setLoader(true));
    let stateAuth = yield select(getStateAuth);

    const _data = stateAuth.formLogin;
    const _body = {
      email: _data.email,
      password: _data.password,
    };

    let _body2 = new FormData();
    _body2.append("email", _data.email);
    _body2.append("password", _data.password);

    const response = yield call(POST, Config.BASE_URL + Endpoint.MODULE_AUTH_CHECK_USER_LOGIN, _body, { headers: Header() });

    if (response.data) {
      const _responseData = response.data;
      if (_responseData.f_hak_akses == 11) {
        // hak akses dokter
        if (response.acknowledge == 1) {
          let _userData = {
            f_id_dokter: _responseData.f_id_dokter,
            f_email_userm: _responseData.f_email_dokter,
            f_nama_userm: _responseData.f_nama_dokter,
            f_telepon_userm: _responseData.f_telepon_dokter,
            f_hak_akses: _responseData.f_hak_akses,
            f_id_klinik: _responseData.f_id_klinik,
            f_nama_klinik: _responseData.f_nama_klinik,
            f_id_poli: _responseData.f_id_poli,
            f_nama_poliklinik: _responseData.f_nama_poliklinik,
          };
          localStorage.setItem("UserData", JSON.stringify(_userData));

          let defaultPath = "";
          if (_responseData) {
            const _hakAkses = _responseData.f_hak_akses;
            defaultPath = _hakAkses == 1 ? "/dashboard/" : _hakAkses == 22 ? "/dashboard/" : _hakAkses == 11 ? "/dashboard-dokter/" : "/dashboard-apotek/";
          }
          messagesRedirect("Login Berhasil", response.message, "success", false, params.history, defaultPath);
        } else {
          messages("Login Gagal", response.message, "warning", false, false);
        }
      } else {
        // hak akses lain kecuali dokter
        if (_responseData.f_id_klinik) {
          let _userData = {
            f_email_userm: _responseData.f_email_userm,
            f_nama_userm: _responseData.f_nama_userm,
            f_telepon_userm: _responseData.f_telepon_userm,
            f_date_register: _responseData.f_date_register,
            f_hak_akses: _responseData.f_hak_akses,
            f_id_klinik: _responseData.f_id_klinik,
            f_nama_klinik: _responseData.f_nama_klinik,
          };
          localStorage.setItem("UserData", JSON.stringify(_userData));

          let defaultPath = "";
          if (_responseData) {
            const _hakAkses = _responseData.f_hak_akses;
            defaultPath = _hakAkses == 1 ? "/dashboard/" : _hakAkses == 22 ? "/dashboard/" : _hakAkses == 11 ? "/dashboard-dokter/" : "/manajemen-persediaan/obat";
          }
          messagesRedirect("Login Berhasil", response.message, "success", false, params.history, defaultPath);
        } else {
          let _userData = {
            f_email_userm: _responseData.f_email_userm,
            f_nama_userm: _responseData.f_nama_userm,
            f_telepon_userm: _responseData.f_telepon_userm,
            f_date_register: _responseData.f_date_register,
            f_hak_akses: _responseData.f_hak_akses,
            f_id_klinik: _responseData.f_id_klinik,
            f_nama_klinik: _responseData.f_nama_klinik,
          };
          localStorage.setItem("UserData", JSON.stringify(_userData));
          messagesRedirect("Login Berhasil", response.message, "success", false, params.history, `/auth/welcome-hicare`);
        }
      }
    } else {
      messages("Login Gagal", response.message, "warning", false, false);
    }

    yield put(setLoader(false));
  } catch (error) {
    yield put(setLoader(false));
    messages("Error", error, "error", false, false);
  }
}

export function* postSubmitRegister(params) {
  try {
    yield put(setLoader(true));
    let stateAuth = yield select(getStateAuth);

    const _data = stateAuth.formRegister;
    const _body = {
      f_email_userm: _data.f_email_userm,
      f_nama_userm: _data.f_nama_userm,
      f_telepon_userm: _data.f_telepon_userm,
      f_password_userm: _data.f_password_userm,
      f_date_register: moment().format("YYYY-MM-DD HH:mm:ss"),
    };

    const response = yield call(POST, Config.BASE_URL + Endpoint.MODULE_AUTH_REGISTER_MASTER_KLINIK, _body, { headers: Header() });

    if (response.acknowledge == 1) {
      messages("Registerasi Akun Berhasil", response.message, "success", false, params.history);
    }
    if (response.acknowledge == 0) {
      messages("Registrasi Gagal", response.message, "warning", false, false);
    }

    yield put(setLoader(false));
  } catch (error) {
    yield put(setLoader(false));
    messages("Error", error, "error", false, false);
  }
}

export function* postSubmitRegisterKlinik(params) {
  try {
    yield put(setLoader(true));
    let stateAuth = yield select(getStateAuth);

    const _data = stateAuth.formRegisterKlinik;
    const _body = {
      f_nama_klinik: _data.f_nama_klinik,
      f_email_klinik: _data.f_email_klinik,
      f_telepon_klinik: _data.f_telepon_klinik,
      f_date_register: moment().format("YYYY-MM-DD HH:mm:ss"),
      f_no_alamat_klinik: _data.f_no_alamat_klinik,
      f_id_negara: 100,
      f_id_provinsi: _data.f_temp_lokasi[0],
      f_id_kabupaten: _data.f_temp_lokasi[1],
      f_id_kecamatan: _data.f_temp_lokasi[2],
      f_id_desa: _data.f_temp_lokasi[3],
      f_status: 0,
      f_email_userm: JSON.parse(localStorage.getItem("UserData")).f_email_userm,
    };

    const response = yield call(POST, Config.BASE_URL + Endpoint.MODULE_AUTH_REGISTER_DATA_KLINIK, _body, { headers: Header() });

    if (response.acknowledge == 1) {
      const _responseData = response.data;

      let _userData = {
        f_email_userm: JSON.parse(localStorage.getItem("UserData")).f_email_userm,
        f_nama_userm: JSON.parse(localStorage.getItem("UserData")).f_nama_userm,
        f_telepon_userm: JSON.parse(localStorage.getItem("UserData")).f_telepon_userm,
        f_date_register: JSON.parse(localStorage.getItem("UserData")).f_date_register,
        f_hak_akses: JSON.parse(localStorage.getItem("UserData")).f_hak_akses,
        f_id_klinik: _responseData.f_id_klinik,
        f_nama_klinik: _responseData.f_nama_klinik,
      };
      localStorage.setItem("UserData", JSON.stringify(_userData));

      messagesRedirect("Registerasi Klinik Berhasil", response.message, "success", false, params.history, `/`);
    }
    if (response.acknowledge == 0) {
      messages("Registrasi Gagal", response.message, "warning", false, false);
    }

    yield put(setLoader(false));
  } catch (error) {
    yield put(setLoader(false));
    messages("Error", error, "error", false, false);
  }
}

export function* postVerifikasiPassword(params) {
  try {
    yield put(setLoader(true));
    let stateAuth = yield select(getStateAuth);

    const _body = {
      email: params.email,
      hakAkses: stateAuth.directURL.hakAkses,
      password: params.password,
      generatedUri: params.generatedUri,
    };

    const response = yield call(POST, Config.BASE_URL + Endpoint.MODULE_AUTH_VERIFIKASI_PASSWORD, _body, { headers: Header() });
    if (response.acknowledge == 1) {
      messagesRedirect("Verifikasi Berhasil", response.message, "success", false, params.history, "/auth/login");
    } else if (response.acknowledge == 0) {
      messages("Maaf, Verifikasi Gagal", response.message, "warning", false, false);
    } else {
      messages("Error", response.message, "error", false, false);
    }

    yield put(setLoader(false));
  } catch (error) {
    yield put(setLoader(false));
    messages("Error", error, "error", false, false);
  }
}

export function* checkDirectURL(params) {
  try {
    yield put(setLoader(true));

    const _body = {
      email: params.email,
      generatedUri: params.generatedUri,
    };

    const response = yield call(POST, Config.BASE_URL + Endpoint.MODULE_AUTH_CHECK_URL_POST, _body, { headers: Header() });

    // buat kasih delay untuk gaya2an
    const delay = (time) => new Promise((resolve) => setTimeout(resolve, time));

    yield all(yield call(delay, 3000), yield put({ type: types.MODULE_AUTH_CHECK_URL_SUCCESS, value: response.data }));

    yield put(setLoader(false));
  } catch (error) {
    yield put(setLoader(false));
    messages("Error", error, "error", false, false);
  }
}

export default function* rootSaga() {
  yield all([
    takeLatest(types.MODULE_AUTH_SUBMIT_FORM_LOGIN, postLogin),
    takeLatest(types.MODULE_AUTH_SUBMIT_FORM_REGISTER, postSubmitRegister),
    takeLatest(types.MODULE_AUTH_SUBMIT_FORM_REGISTER_KLINIK, postSubmitRegisterKlinik),
    takeLatest(types.MODULE_AUTH_SUBMIT_VERIFIKASI_PASSWORD, postVerifikasiPassword),
    takeLatest(types.MODULE_AUTH_CHECK_URL, checkDirectURL),
  ]);
}
